import React, {useEffect, useState} from "react"
import {connect} from "react-redux";

import {selectNewAreaDispatchAction} from "../../../state/geoMap/dispatchActions";
import {getScopeConfigurationFieldsBy, getSyncSearchFormValuesByState} from "../../../helpers/configurationHelper";
import {ConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import translations from "../../../translations";
import {Button, Form as BootstrapForm} from "react-bootstrap";
import {convertCircleCoordinatesIntoShape} from "../../../helpers/shapeHelper";
import {Picky} from "react-picky";
import InputText from "../../shared/inputs/InputText";
import BootstrapToggle from "react-bootstrap-toggle";
import {convertDegreesMinutesSecondsToDecimal} from "../../../helpers/coordinatesHelper";
import {SearchResultsType} from "../../../types/product";

interface PropsType {
    configurations: ConfigurationsType,
    selectedArea: ShapeType,
    values: any,
    updatePathCoordinatesActionHandler: any,
    language: string,
    selectNewAreaDispatchActionHandler: any,
    handleCloseModal: any,
    searchByProducts: boolean,
    searchResults: SearchResultsType
}

const CircleAOIHelper = (props: PropsType) => {
    const {
        configurations,
        selectNewAreaDispatchActionHandler,
        language,
        values,
        handleCloseModal,
        searchByProducts,
        searchResults
    } = props;

    const [lat, setLat] = useState('');
    const [lng, setLng] = useState('');
    const [typeLat, setTypeLat] = useState(translations('nord', language));
    const [typeLng, setTypeLng] = useState(translations('east', language));

    const [radius, setRadius] = useState('');
    const [units, setUnits] = useState('kilometers');
    const [isDecimalDegrees, setIsDecimalDegrees] = useState(true);
    const [degreesX, setDegreesX] = useState('');
    const [minutesX, setMinutesX] = useState('');
    const [secondsX, setSecondsX] = useState('');
    const [degreesY, setDegreesY] = useState('');
    const [minutesY, setMinutesY] = useState('');
    const [secondsY, setSecondsY] = useState('');
    const [typeX, setTypeX] = useState(translations('east', language));
    const [typeY, setTypeY] = useState(translations('north', language));

    const unitOptions = [
        translations('meters', language),
        translations('kilometers', language),
        translations('miles', language)
    ];

    const optionsX = [
        translations('ovest', language),
        translations('east', language)
    ];

    const optionsY = [
        translations('nord', language),
        translations('sud', language)
    ];

    useEffect(()=>{
        setRadius('');
    },[isDecimalDegrees])

    const drawCircleHandler = () => {

        //0.1278 51.5074 70000
        let convertedRadius: number = parseInt(radius);

        switch (units) {
            case unitOptions[1]:
                convertedRadius = convertedRadius * 1000;
                break;
            case unitOptions[2]:
                convertedRadius = convertedRadius * 1000 * 1.60934;
                break;
        }

        let newShape;

        if (!isDecimalDegrees) {
            // convert non decimal degrees
            const latDegrees = typeY === translations('nord', language) ? parseFloat(degreesY) : parseFloat(`-${degreesY}`);
            const latMinutes = typeY === translations('nord', language) ? parseFloat(minutesY) : parseFloat(`-${minutesY}`);
            const latSeconds = typeY === translations('nord', language) ? parseFloat(secondsY) : parseFloat(`-${secondsY}`);
            const newLat = convertDegreesMinutesSecondsToDecimal(+latDegrees, +latMinutes, +latSeconds);

            const lonDegrees = typeX === translations('east', language) ? parseFloat(degreesX) : parseFloat(`-${degreesX}`);
            const lonMinutes = typeX === translations('east', language) ? parseFloat(minutesX) : parseFloat(`-${minutesX}`);
            const lonSeconds = typeX === translations('east', language) ? parseFloat(secondsX) : parseFloat(`-${secondsX}`);
            const newLng = convertDegreesMinutesSecondsToDecimal(+lonDegrees, +lonMinutes, +lonSeconds);

            newShape = convertCircleCoordinatesIntoShape(newLat, newLng, convertedRadius);
        } else {
            newShape = convertCircleCoordinatesIntoShape(parseFloat(`${typeLat === 'sud' ? '-': ''}${lat.replace(',', '.')}`), parseFloat(`${typeLng === 'ovest' ? '-': ''}${lng.replace(',', '.')}`), convertedRadius);
        }

            selectNewAreaDispatchActionHandler(configurations, "", getScopeConfigurationFieldsBy(configurations), values, newShape, language, searchByProducts, searchResults);
            handleCloseModal();

    };

    const isButtonDisabled = ()=>{
        return isDecimalDegrees ? (!lat || !lng || !radius) :
            (!degreesX || !minutesX || !secondsX || !degreesY || !minutesY || !secondsY || !radius);
    };

    return (
        <>
            {isDecimalDegrees ?
                <div className={"row mx-0 mb-3"}>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="Lat">
                      <span>
                        {translations('latitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="lat"
                                onChange={(e) => {
                                    setLat(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('upperCornerLatPlaceholder',language)}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsY}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLat}
                                onChange={(e) => {
                                    setTypeLat(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 mb-3 flex-column'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="Lng">
                      <span>
                        {translations('longitude', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="lng"
                                onChange={(e) => {
                                    setLng(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('upperCornerLngPlaceholder',language)}
                            />
                            {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0 d-flex pl-3"}
                            title="typeY">
                      <span>
                          &nbsp;
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={optionsX}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={typeLng}
                                onChange={(e) => {
                                    setTypeLng(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-6 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="radius">
                      <span>
                        {translations('radius', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <InputText
                                name="radius"
                                onChange={(e) => {
                                    setRadius(e.target.value)
                                }}
                                className="m-0 form-control"
                                defaultValue={''}
                                disabled={false}
                                placeholder={translations('radiusPlaceholder',language)}

                            />
                            {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                        </BootstrapForm.Group>
                    </div>
                    <div className={'m-0 px-2 d-flex col-6 flex-column mb-3'}>
                        <BootstrapForm.Label
                            className={"m-0 px-0"}
                            title="radius">
                      <span>
                        {translations('units', language)}
                      </span>
                        </BootstrapForm.Label>
                        <BootstrapForm.Group
                            className={"m-0 pr-0"}>
                            <Picky
                                numberDisplayed={1}
                                options={unitOptions}
                                valueKey="value"
                                labelKey="label"
                                keepOpen={false}
                                multiple={false}
                                includeSelectAll={false}
                                value={units}
                                onChange={(e) => {
                                    setUnits(e as string)
                                }}
                                dropdownHeight={140}
                                disabled={false}
                            />
                        </BootstrapForm.Group>
                    </div>
                </div> :
                <>
                    <div className={"row mx-0 mb-3"}>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex "}
                                title="DegY">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="degY"
                                    onChange={(e) => {
                                        setDegreesY(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLatPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex  pl-3"}
                                title="MinY">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="minY"
                                    onChange={(e) => {
                                        setMinutesY(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLatPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex "}
                                title="SecY">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="secY"
                                    onChange={(e) => {
                                        setSecondsY(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLatPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeY">
                      <span>
                        {translations('latitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsY}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeY}
                                    onChange={(e) => {
                                        setTypeY(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                    </div>
                    <div className={"row mx-0 mb-3"}>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex "}
                                title="DegX">
                      <span>
                        {translations('degrees', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 "}>
                                <InputText
                                    name="degX"
                                    onChange={(e) => {
                                        setDegreesX(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('degreesLngPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="MinX">
                      <span>
                        {translations('minutes', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="minX"
                                    onChange={(e) => {
                                        setMinutesX(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('minutesLngPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex"}
                                title="SecX">
                      <span>
                        {translations('seconds', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <InputText
                                    name="secX"
                                    onChange={(e) => {
                                        setSecondsX(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('secondsLngPlaceholder',language)}
                                />
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-2 d-flex col-3 flex-column mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex pl-3"}
                                title="typeX">
                      <span>
                        {translations('longitude', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={optionsX}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={typeX}
                                    onChange={(e) => {
                                        setTypeX(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                    </div>
                    <div className={"row mx-0 mb-3"}>
                        <div className={'m-0 px-0 d-flex col-6 mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex col-3"}
                                title="radius">
                      <span>
                        {translations('radius', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 col-9"}>
                                <InputText
                                    name="radius"
                                    onChange={(e) => {
                                        setRadius(e.target.value)
                                    }}
                                    className="m-0 form-control"
                                    defaultValue={''}
                                    disabled={false}
                                    placeholder={translations('radiusPlaceholder',language)}
                                />
                                {/*<BootstrapForm.Control.Feedback type="invalid">{errorMessage}</BootstrapForm.Control.Feedback>*/}
                            </BootstrapForm.Group>
                        </div>
                        <div className={'m-0 px-0 d-flex col-6 mb-3'}>
                            <BootstrapForm.Label
                                className={"m-0 px-0 d-flex col-3 pl-3"}
                                title="radius">
                      <span>
                        {translations('units', language)}
                      </span>
                            </BootstrapForm.Label>
                            <BootstrapForm.Group
                                className={"m-0 pr-0 col-9"}>
                                <Picky
                                    numberDisplayed={1}
                                    options={unitOptions}
                                    valueKey="value"
                                    labelKey="label"
                                    keepOpen={false}
                                    multiple={false}
                                    includeSelectAll={false}
                                    value={units}
                                    onChange={(e) => {
                                        setUnits(e as string)
                                    }}
                                    dropdownHeight={140}
                                    disabled={false}
                                />
                            </BootstrapForm.Group>
                        </div>
                    </div>
                </>
            }
            <div className={'row'}>
                <div className={'m-0 px-0 d-flex col-12 mb-3 ml-3 switch-container'}>
                    <BootstrapToggle
                        id="circle-degrees"
                        name="circle-degrees"
                        disabled={false}
                        onClick={() => setIsDecimalDegrees(!isDecimalDegrees)}
                        on={translations('rawDegrees', language)}
                        onClassName="mode-switch-routine"
                        off={translations('degMinSec', language)}
                        offClassName="mode-switch-ondemand"
                        handleClassName="container-mode-switch"
                        active={isDecimalDegrees}
                        height="28px"
                        width="190px"
                    />
                </div>
            </div>
            <div className={"row mx-0"}>
                <div className={'m-0 px-0 d-flex col-12'}>
                    <p>{translations('circleCenterToolDisclaimer', language)}</p>
                </div>
            </div>
            <Button onClick={drawCircleHandler} className={"float-right"} disabled={isButtonDisabled()}>
                <span>{translations('done', language)}</span>
            </Button>
        </>
    );
};

const mapStateToProps = (state) => ({
    configurations: state.application.configurations,
    selectedArea: state.geoMap.lastShape,
    values: getSyncSearchFormValuesByState(state),
    language: state.application.appParameters.language,
    searchByProducts: state.geoMap.searchByProducts,
    searchResults: state.product.searchResults
});

const mapDispatchToProps = (dispatch) => ({
    selectNewAreaDispatchActionHandler: (configurations, appParameters, scopeFields, formValues, newShape, language, searchByProducts, searchResults) => dispatch(selectNewAreaDispatchAction(configurations, appParameters, scopeFields, formValues, newShape, language, searchByProducts, searchResults))
});

export default connect(mapStateToProps, mapDispatchToProps)(CircleAOIHelper);
